import { cn } from "@/modules/lib/utils"
import { HuAvatarCardSidebarSkeleton } from "@/modules/ui/components/huAvatarCardSidebarSkeleton"
import { useTransactionDetails } from "@modules/finances/hooks/useFinance"
import { TransactionDetailsContainer } from "@modules/finances/transactions/components/transactionDetailsContainer"
import { ApiFinanceType } from "@modules/finances/types/financesType"
import { HuAvatarCardSidebar } from "@modules/ui/components/huAvatarCardSidebar"
import { Suspense } from "react"

type TransactionsDetailsProps = {
  transactionId: string
} & React.ComponentProps<"div">

export function UserTransactionsDetailsLayout({ transactionId, className, ...props }: TransactionsDetailsProps) {
  const { data: transactionDetails } = useTransactionDetails(transactionId)

  return (
    <div className={cn("h-full", className)} {...props}>
      <>
        <Suspense fallback={<HuAvatarCardSidebarSkeleton />}>
          {transactionDetails.box ? (
            <HuAvatarCardSidebar
              id={transactionDetails.box.id}
              avatar={transactionDetails.box.logo}
              firstname={transactionDetails.box.name}
              lastname=""
              email={transactionDetails.box.email}
              canUseContact={true}
              canUseChatContact={false}
              nationality={transactionDetails.box.nationality ?? undefined}
            />
          ) : transactionDetails.user ? (
            <HuAvatarCardSidebar
              id={transactionDetails.user.id}
              avatar={transactionDetails.user.avatar ?? undefined}
              firstname={transactionDetails.user.firstname}
              lastname={transactionDetails.user.lastname}
              username={transactionDetails.user.username}
              prefixUsername={transactionDetails.user.username ? "@" : undefined}
              email={transactionDetails.user.email}
              canUseContact={true}
              canUseChatContact={true}
            />
          ) : null}
        </Suspense>

        <TransactionDetailsContainer transactionDetails={transactionDetails} apiFinanceType={ApiFinanceType.USER} />
      </>
    </div>
  )
}
